export default __webpack_public_path__ + "static/media/nc_1.9ff55668.png";